import React from 'react';
import { Box, Link, Typography, IconButton } from '@material-ui/core';
import { ArrowBack, InfoOutlined, OpenInNew, Phone } from '@material-ui/icons';
import { colors } from '@loggi/mar';
import PropTypes from 'prop-types';

export const phones = {
  firefighter: { name: 'Bombeiros', phone: '193' },
  EMS: { name: 'SAMU', phone: '192' },
  police: { name: 'Polícia', phone: '190' }
};

export const helpCenterUrl = 'https://ajuda.loggi.com/hc/pt-br/requests/new';

export const texts = {
  title: 'Emergência',
  immediateHelpTitle: 'Precisa de ajuda imediata?',
  immediateHelp:
    'Se você sofreu um acidente ou necessita de socorro, clique no botão do órgão desejado para iniciar a chamada gratuita.',
  cargoHelp:
    'Em caso de problemas com a carga (perda ou sinistro) ou falhas no app, abra um chamado pela',
  helpCenter: 'Central de Ajuda',
  returnHelp:
    "Se o problema for relacionado à devolução, clique no botão 'Quero devolver' do seu aplicativo. Caso ainda esteja com pacotes em posse, realize a devolução no primeiro horário do próximo dia útil."
};

export default function DriversEmergency({ goBack }) {
  return (
    <Box
      bgcolor={colors.root[0]}
      display="flex"
      flexDirection="column"
      py={2.5}
    >
      <Box flexGrow={1}>
        <Box px={0.7} pb={2}>
          <IconButton onClick={goBack} data-testid="back-button">
            <ArrowBack style={{ color: colors.blue[500] }} />
          </IconButton>
        </Box>
        <Box p={2.5}>
          <Box color={colors.root[900]}>
            <Typography variant="h5">{texts.title}</Typography>
          </Box>
          <Box pt={2} color={colors.root[900]}>
            <Typography variant="subtitle1">
              {texts.immediateHelpTitle}
            </Typography>
          </Box>
          <Box py={1.25} color={colors.smoke[800]}>
            <Typography variant="body1">{texts.immediateHelp}</Typography>
          </Box>
        </Box>
        {Object.values(phones).map(item => (
          <Box mx={2.5} key={item.name}>
            <Box
              bgcolor={colors.smoke[50]}
              borderRadius={8}
              my={2.5}
              p={2}
              display="flex"
              justifyContent="space-between"
            >
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
              >
                <Box pb={0.5} color={colors.smoke[700]}>
                  <Typography variant="body2">Ligar {item.phone}</Typography>
                </Box>
                <Box color={colors.smoke[900]}>
                  <Typography variant="subtitle1">{item.name}</Typography>
                </Box>
              </Box>

              <Box p={1.5} data-testid="recipient-phone">
                <IconButton
                  variant="outlined"
                  style={{
                    height: '40px',
                    width: '40px',
                    border: `solid 1px ${colors.blue[500]}`,
                    color: colors.blue[500],
                    backgroundColor: colors.root[0]
                  }}
                  data-testid="recipient-phone-button"
                  aria-label={`Ligar para ${item.name}`}
                  onClick={() => {
                    window.location.href = `tel:${item.phone}`;
                  }}
                >
                  <Phone />
                </IconButton>
              </Box>
            </Box>
          </Box>
        ))}
        <Box
          mx={2.5}
          mb={2.5}
          p={2}
          display="flex"
          bgcolor={colors.blue[50]}
          borderRadius={8}
        >
          <Box pr={1.5} color={colors.blue[500]} aria-hidden>
            <InfoOutlined />
          </Box>
          <Box color={colors.smoke[900]}>
            <Typography variant="body2">
              {texts.cargoHelp}{' '}
              <Link href={helpCenterUrl} style={{ color: colors.blue[700] }}>
                {texts.helpCenter}
                <OpenInNew
                  style={{
                    fontSize: 14,
                    marginLeft: 4,
                    verticalAlign: 'middle'
                  }}
                />
              </Link>
              .
            </Typography>
            <Box pt={1.5}>
              <Typography variant="body2">{texts.returnHelp}</Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

DriversEmergency.propTypes = {
  goBack: PropTypes.func.isRequired
};
